import { Injectable } from '@angular/core';

import { ApiService } from './api.service';

import { Book }       from '../models/book';

@Injectable()
export class CrawlService {
  public constructor(private apiService: ApiService) {
  }
  public getBook(source: string, sourceId: string, options?: Object): Promise<Book> {
    return this.apiService.call(`crawl/${source}/${sourceId}`, 'GET', options);
  }
  public getBookDetail(bookId, options?) {
    let endPoint = `crawl/${bookId}`;

    return this.apiService.call(endPoint, 'GET', options);
  }
  public getBookChapters(bookId, options?) {
    let endPoint = `crawl/${bookId}/chapters`;

    return this.apiService.call(endPoint, 'GET', options);
  }
}



// WEBPACK FOOTER //
// ./src/services/crawl.service.ts